import { inject, Injectable } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { CareerPlansState } from './career-plans.state';
import { Observable } from 'rxjs';
import { SetLevel, SetSkill } from './career-plans.actions';
import { CareerPlanLevel, CareerPlanSkill } from '../../models/career-plans';

@Injectable({
  providedIn: 'root',
})
export class CareerPlansFacade {
  private readonly store = inject(Store);

  @Select(CareerPlansState.selectedSkill) selectedSkill$: Observable<CareerPlanSkill | undefined>;
  @Select(CareerPlansState.selectedLevel) selectedLevel$: Observable<CareerPlanLevel | undefined>;

  get selectedSkill(): CareerPlanSkill | undefined {
    return this.store.selectSnapshot(CareerPlansState.selectedSkill);
  }

  get selectedLevel(): CareerPlanLevel {
    return this.store.selectSnapshot(CareerPlansState.selectedLevel);
  }

  setSkill(skill?: CareerPlanSkill) {
    this.store.dispatch(new SetSkill(skill));
  }

  setLevel(level?: CareerPlanLevel) {
    this.store.dispatch(new SetLevel(level));
  }
}
